import { Box, Button, Stack, Typography } from '@mui/material';
import { ArrowBack, AutoAwesome } from '@mui/icons-material';
import { colors, primaryGradient } from '../styles';

interface ReturnBarProps {
    /** הנתיב שהמשתמש ביקש לפני שהופנה לכאן */
    returnTo: string;
    onContinue: () => void;
    onDismiss: () => void;
}

/**
 * מוצג כשהמשתמש הופנה לדף מתוך נתיב אחר (למשל סימנייה ל-/orders) —
 * מאפשר לו לחזור למסך שרצה בלחיצה אחת.
 */
const ReturnBar = ({ returnTo, onContinue, onDismiss }: ReturnBarProps) => (
    <Box
        dir="rtl"
        sx={{
            position: 'sticky',
            top: 8,
            zIndex: 5,
            borderRadius: '18px',
            px: { xs: 2, md: 3 },
            py: 1.5,
            bgcolor: 'rgba(255,255,255,0.94)',
            backdropFilter: 'blur(8px)',
            border: `1px solid ${colors.border}`,
            boxShadow: '0 12px 32px rgba(15, 50, 80, 0.14)'
        }}
    >
        <Stack
            dir="rtl"
            direction={{ xs: 'column', sm: 'row' }}
            spacing={1.5}
            alignItems={{ xs: 'stretch', sm: 'center' }}
            justifyContent="space-between"
        >
            <Stack direction="row" spacing={1.2} alignItems="center">
                <AutoAwesome sx={{ color: '#0aa6a6' }} />
                <Typography sx={{ fontWeight: 800, color: colors.ink }}>ריכזנו כאן את היכולות החדשות — שווה הצצה של דקה</Typography>
            </Stack>
            <Stack direction="row" spacing={1}>
                <Button onClick={onDismiss} sx={{ fontWeight: 800, color: colors.body }}>
                    אני רוצה לראות מה חדש
                </Button>
                <Button
                    variant="contained"
                    startIcon={<ArrowBack sx={{ transform: 'scaleX(-1)' }} />}
                    onClick={onContinue}
                    sx={{ borderRadius: '999px', px: 2.5, fontWeight: 900, background: primaryGradient }}
                >
                    המשך למסך שביקשת
                </Button>
            </Stack>
        </Stack>
        <Typography sx={{ color: colors.muted, fontSize: 12, mt: 0.5 }}>{returnTo}</Typography>
    </Box>
);

export default ReturnBar;
